import React, { useEffect, useRef, useState } from 'react';

function AnimatedCounter({ end, duration = 2000, suffix = '' }) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setStarted(true);
    }, { threshold: 0.5 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return;
    const numEnd = parseInt(end) || 0;
    const step = numEnd / (duration / 16);
    let current = 0;
    const timer = setInterval(() => {
      current += step;
      if (current >= numEnd) {
        setCount(numEnd);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [started, end, duration]);

  return <span ref={ref}>{count.toLocaleString()}{suffix}</span>;
}

export default function StatsSection({ content }) {
  const { title, subtitle, stats, background_color } = content || {};

  return (
    <section className="py-20 relative overflow-hidden" style={{ background: background_color || 'linear-gradient(135deg, #081626, #00CFFF)' }}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-white rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full blur-3xl" style={{ backgroundColor: '#66E0FF' }} />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {(title || subtitle) && (
          <div className="text-center mb-12">
            {title && <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">{title}</h2>}
            {subtitle && <p className="text-lg" style={{ color: 'rgba(255,255,255,0.85)' }}>{subtitle}</p>}
          </div>
        )}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {(stats || [
            { label: 'Tahun Pengalaman', value: '4', suffix: '+' },
            { label: 'Pelanggan', value: '10000', suffix: '+' },
            { label: 'Produk', value: '12', suffix: '' },
            { label: 'Kota Terjangkau', value: '50', suffix: '+' },
          ]).map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-2">
                <AnimatedCounter end={stat.value} suffix={stat.suffix || ''} />
              </div>
              <p className="text-sm sm:text-base" style={{ color: 'rgba(255,255,255,0.85)' }}>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}